import React, { useState } from 'react';
import { Form, Input, Button, List, Space, Typography, notification } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { createCustomFieldOption, deleteCustomFieldOption } from '../../api/custom_fields';
import { useSettingsState } from '../../state/settingsState';
import styles from './SelectFieldOptions.module.css';

const { Text } = Typography;

const FieldOptions = ({ field, statusId, checklistId, onOptionsChange }) => {
	const [newOptionValue, setNewOptionValue] = useState('');
	const [loading, setLoading] = useState(false);
	const { checklists, setChecklists } = useSettingsState();

	const getFieldLabel = () => {
		return field.type === 'S' ? 'Опции селектора' : 'Опции мультисписка';
	};

	const handleAddOption = async () => {
		if (!newOptionValue.trim()) return;

		setLoading(true);
		try {
			const option = await createCustomFieldOption(statusId, checklistId, field.id, {
				value: newOptionValue
			});

			if (!option) throw new Error('Не удалось создать опцию');

			const updatedOptions = [...(field.options || []), option];
			onOptionsChange(updatedOptions);
			
			const updatedChecklists = checklists.map(checklist => {
				if (checklist.id === checklistId) {
					return {
						...checklist,
						custom_fields: checklist.custom_fields.map(cf => {
							if (cf.id === field.id) {
								return {
									...cf,
									options: updatedOptions
								};
							}
							return cf;
						})
					};
				}
				return checklist;
			});
			setChecklists(updatedChecklists);
			
			setNewOptionValue('');
		} catch (error) {
			notification.error({
				message: 'Ошибка',
				description: 'Не удалось создать опцию',
				placement: 'bottomRight'
			});
		} finally {
			setLoading(false);
		}
	};

	const handleDeleteOption = async (optionId) => {
		setLoading(true);
		try {
            if (!field || (typeof field.id !== 'number' && typeof field.id !== 'string')) {
                throw new Error('Некорректный идентификатор поля');
            }
            const success = await deleteCustomFieldOption(statusId, checklistId, field.id, optionId);

			if (!success) throw new Error('Не удалось удалить опцию');

            const updatedOptions = (field.options || []).filter(opt => opt.id !== optionId);
			onOptionsChange(updatedOptions);
			
			const updatedChecklists = checklists.map(checklist => {
				if (checklist.id === checklistId) {
					return {
						...checklist,
						custom_fields: checklist.custom_fields.map(cf => {
							if (cf.id === field.id) {
								return {
									...cf,
									options: updatedOptions
								};
							}
							return cf;
						})
					};
				}
				return checklist;
			});
			setChecklists(updatedChecklists);
			
		} catch (error) {
			notification.error({
				message: 'Ошибка',
				description: 'Не удалось удалить опцию',
				placement: 'bottomRight'
			});
		} finally {
			setLoading(false);
		}
	};

	return (
		<div>
			<Form.Item label={getFieldLabel()}>
				<List
					size="small"
					bordered
					dataSource={field.options || []}
					className={styles.optionsList}
					renderItem={option => (
						<List.Item
							actions={[
								<Button
									type="text"
									danger
									icon={<DeleteOutlined />}
									onClick={() => handleDeleteOption(option.id)}
									disabled={loading}
								/>
							]}
						>
							<Text>{option.value}</Text>
						</List.Item>
					)}
				/>

				<Space.Compact style={{ width: '100%', marginTop: '16px' }}>
					<Input
						value={newOptionValue}
						onChange={(e) => setNewOptionValue(e.target.value)}
						placeholder="Значение новой опции"
						disabled={loading}
					/>
					<Button
						type="primary"
						icon={<PlusOutlined />}
						onClick={handleAddOption}
						disabled={!newOptionValue.trim() || loading}
						loading={loading}
					>
						Добавить
					</Button>
				</Space.Compact>
			</Form.Item>
		</div>
	);
};

export default FieldOptions; 